import styled from 'styled-components';

export const AppCardStyled = styled.div`
	gap: 16px;
	display: flex;
	padding: 12px 16px;
	width: 100%;
	&:hover {
		background-color: #e6f7ff;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		padding: 16px;
		width: 332px;
		border: 1px solid #f5f5f5;
		&:hover {
			background-color: transparent;
		}
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 332px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 444px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 384px;
	}
`;

export const AppCardImgStyled = styled.img`
	width: 64px;
	height: 64px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 87px;
		height: 87px;
	}
`;

export const AppCardTextContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 8px;
		padding: 8px 0;
	}
`;

export const AppCardNameStyled = styled.h3`
	margin: 0;
	color: #262626;
	font-weight: 600;
	font-size: 16px;
`;

export const BadgeContainerStyled = styled.div`
	display: inline;
`;

export const AppCardDescriptionStyled = styled.p`
	margin: 0;
	color: #595959;
	font-weight: 300;
	font-size: 14px;
	line-height: 22px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-weight: 400;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 12px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 14px;
	}
`;
